import React, { useEffect } from "react";
import { makeStyles, useTheme } from "@seahorse/ui";
import logo from "../assets/logo-new.png"; // Adjust the path as per your folder structure

const AboutEmalphaTile = () => {
  const theme = useTheme();

  const useStyles = makeStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
      padding: "16px",
      backgroundColor: theme.globallink.colors.DarkGrey[500],
      gap: "16px",
    },
    header: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "16px",
    },
    logo: {
      height: "50px",
      width: "auto",
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    card: {
      padding: "16px",
      borderRadius: "8px",
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    },
    cardHeader: {
      fontSize: "20px",
      fontWeight: "bold",
      color: theme.palette.primary.main,
      marginBottom: "8px",
    },
    cardContent: {
      fontSize: "16px",
      lineHeight: "1.6",
    },
  });

  const classes = useStyles();

  useEffect(() => {
    console.log("About Emalpha Tile Loaded");
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <img src={logo} alt="Emalpha Logo" className={classes.logo} />
      </div>
      <div className={classes.content}>
        <div className={classes.card}>
          <div className={classes.cardHeader}>About CoTrader</div>
          <div className={classes.cardContent}>
            EMAlpha CoTrader leverages Generative AI and AI Agents to provide workflow-enhancing applications for FX traders. By analyzing real-time, geographically localized multilingual news flows, macroeconomic data releases, and trade data, its AI Agents deliver real-time information updates. This empowers traders to stay informed about on-the-ground developments and achieve superior trade execution.
            <br />
            <br />
            CoTrader gathers insights from thousands of verified media outlets, publicly available macroeconomic data releases, and high-quality trade data provided by its trusted partners.
          </div>
        </div>
        <div className={classes.card}>
          <div className={classes.cardHeader}>About EMAlpha</div>
          <div className={classes.cardContent}>
            EMAlpha is a pioneer in Multilingual AI. With approximately 50% of online information now residing in non-English languages, EMAlpha identifies and extracts market-moving insights that highlight trends, opportunities, and risks. By valuing all languages equally, EMAlpha ensures its global client base gains access to critical information from across the world.
          </div>
        </div>
        <div className={classes.card}>
          <div className={classes.cardHeader}>Contact Information</div>
          <div className={classes.cardContent}>
            Email: support@emalpha.com
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutEmalphaTile;
